// extracted by mini-css-extract-plugin
export var cardContainer = "_qh-0";
export var cardHeader = "_qh-2";
export var collapsedState = "_qh-3";
export var dragHandle = "_qh-5";
export var dragHandleIcon = "_qh-6";
export var dragging = "_qh-1";
export var titleArea = "_qh-4";